import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { t } from "@/lib/i18n";
import { Lightning } from "@phosphor-icons/react";

let refreshFns = [];
export const refreshTokenWidget = () => refreshFns.forEach((f) => f());

export const TokenWidget = () => {
  const [pool, setPool] = useState(null);
  const navigate = useNavigate();
  const load = () => api.get("/team/tokens").then((r) => setPool(r.data)).catch(() => {});
  useEffect(() => {
    load();
    refreshFns.push(load);
    const iv = setInterval(load, 60000);
    return () => { refreshFns = refreshFns.filter((f) => f !== load); clearInterval(iv); };
  }, []);

  if (!pool) return <div className="h-10 mb-3" />;
  const pct = pool.unlimited ? 0 : Math.min(100, pool.pct_used || 0);
  const barColor = pct >= 95 ? "bg-red-500" : pct >= 80 ? "bg-amber-500" : "bg-blue-500";
  return (
    <button data-testid="token-widget" onClick={() => navigate("/billing")}
      className="w-full text-left mb-3 rounded-lg border border-gray-200 bg-white px-3 py-2 hover:border-blue-300 transition-colors"
      title={t("tokens.tooltip", "Your AI token balance — click for details")}>
      <div className="flex items-center gap-1.5 text-[13px] font-semibold text-gray-800">
        <Lightning size={14} weight="fill" className="text-blue-600" />
        {pool.unlimited
          ? <span data-testid="token-widget-unlimited">{t("tokens.unlimited", "Unlimited")}</span>
          : <span data-testid="token-widget-remaining">{Math.round(pool.remaining).toLocaleString()} <span className="font-normal text-gray-400">{t("tokens.left", "left")}</span></span>}
      </div>
      {pool.unlimited ? (
        <div className="text-[10px] text-gray-400 mt-0.5">{Math.round(pool.consumed).toLocaleString()} {t("tokens.used_month", "used this month")}</div>
      ) : (
        <>
          <div className="h-1.5 rounded-full bg-gray-100 mt-1.5 overflow-hidden">
            <div className={`h-full rounded-full transition-all ${barColor}`} style={{ width: `${pct}%` }} />
          </div>
          <div className="text-[10px] text-gray-400 mt-0.5">{pct}% {t("tokens.of", "of")} {pool.total.toLocaleString()}</div>
        </>
      )}
    </button>
  );
};
